<template>
  <div class="m-0">
    <!-- แถวบน: Map + ตารางรถ -->
    <CRow class="mb-4 m-0">
    <!-- ฝั่งซ้าย: Google Map -->
    <CCol md="6">
        <GoogleMaps ref="googleMaps" :show-cases="false" :center="mapCenter"/>
    </CCol>

    <!-- ฝั่งขวา: Tabs รถ -->
    <CCol md="6">
      <CCard class="bg-style2 bg-gradient-dark" style="min-height:200px;">
        <!-- class="bg-gradient-dark text-white" style=" " -->
        <CTabs variant="tabs" class="p-0 tabs-custom">

          <CTab v-if="canSeeCars">
            <template #title>
              <CIcon name="cil-inbox" class="m-2"/> <span class="font-weight-bold h6">รายการรถทั้งหมด</span> 
            </template>
            <CRow>
              <CCol>
                <carstable :filter="filter" @zoom-to="onZoomTo"/>
              </CCol>
            </CRow>
          </CTab>

          <CTab v-if="canSeeAssets">
            <template #title>
              <CIcon name="cil-inbox" class="m-2"/> <span class="font-weight-bold h6">รายการสินทรัพย์ทั้งหมด</span>
            </template>
            <CRow>
              <CCol>
                <Assetstable :filter="filter"/>
              </CCol>
            </CRow>
            
          </CTab>
        </CTabs>
        </CCard>
      </CCol>
    </CRow>

    <!-- แถวล่าง -->
    <CRow>
      <CCol md="12">
              <CCol>
                <History class="mb-4"  :item="filteredItems" @info="onReadInfo" @case-updated="onCaseUpdated" />
              </CCol>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMaps from '../dashboards/components/GoogleMaps.vue'
import Assetstable from './components/assetstable.vue'
import Assetsrequest from './components/assetsrequest.vue'
import carstable from './components/carstable.vue'
import carsrequest from './components/carsrequest.vue'
import History from "@/projects/views/dashboards/components/history.vue";

export default {
  name: 'Assets',
  components: { GoogleMaps, Assetstable, Assetsrequest, carstable, carsrequest, History },
  data() {
    return {
      // Local filter สำหรับ assets page
      localFilter: {
        status: null,
        type: null,
        levels: null,
        search: ''
      },
      filter: {
        status: 0,
        type: 0,
        levels: 0,
        search: ''
      },
      // map center that can be updated when user requests zoom to a car
      mapCenter: { lat: 20.04, lng: 99.89 }
    }
  },

  mounted() {
    this.onInit()
  },
  methods: {
    onInit() {
      // วิธีที่ 4: ใช้ session storage เพื่อแยก filter
      const savedFilter = sessionStorage.getItem('assetsFilter');
      if (savedFilter) {
        const filter = JSON.parse(savedFilter);
        this.$store.dispatch("Dashboard/filter", filter);
      } else {
        // Reset filter เมื่อเข้า assets page
        this.$store.dispatch("Dashboard/filter", { status: null, type: null, levels: null });
      }
      
      const data = {}
      this.$store.dispatch("Assets/category", data);
      this.$store.dispatch("Assets/subtype", data);
      this.$store.dispatch("Assets/assets", data);
      this.$store.dispatch("Dashboard/reports", data);
      this.$store.dispatch("Dashboard/status", data);
      this.$store.dispatch("Dashboard/type", data);
      this.$store.dispatch("Dashboard/levels", data);
      this.$emit('data-loaded');
    },
    onFilterChange(objs) {
      this.filter = {
        status: objs.status || 0,
        type: objs.type || 0,
        levels: objs.levels || 0,
        search: objs.search || ''
      }
    },
    
    // ใช้ local filter แทน store filter
    onLocalFilterChange(filterData) {
      this.localFilter = { ...filterData };
    },
    
    // วิธีที่ 4: บันทึก filter ลง session storage
    onFilterChangeWithStorage(filterData) {
      this.$store.dispatch("Dashboard/filter", filterData);
      sessionStorage.setItem('assetsFilter', JSON.stringify(filterData));
    }
    ,
    // handle zoom request from carstable
    onZoomTo({ lat, lng, zoom, title, plate, label }) {
      if (lat && lng) {
        // อัปเดต mapCenter
        this.mapCenter = { lat, lng, zoom: zoom || 16 };
        
        // แสดง InfoWindow พร้อม title (ใช้ label ถ้ามี ไม่งั้นใช้ title หรือ title + plate)
        const carTitle = label || (title && plate ? `${title} (${plate})` : title || plate || 'รถ');
        
        // เรียก method ใน GoogleMaps component เพื่อแสดง InfoWindow
        this.$nextTick(() => {
          if (this.$refs.googleMaps) {
            this.$refs.googleMaps.showInfoWindowAt({ lat, lng }, carTitle);
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      lang: 'setting/lang',
      reports: 'Dashboard/reports',
      status: 'Dashboard/status',
      type: 'Dashboard/type',
      levels: 'Dashboard/levels',
      filter: 'Dashboard/filter',
      loading: 'Dashboard/loading',
      error: 'Dashboard/error',
      selectedUser: 'Auth/selectedUser',
    }),
    
    // บทบาทผู้ใช้
    allRoles() {
      return this.selectedUser?.authen?.flatMap(a => a.roles) || [];
    },
    canSeeAssets() {
      return this.allRoles.includes('1') || this.allRoles.includes('3');
    },
    canSeeCars() {
      return this.allRoles.includes('2') || this.allRoles.includes('3');
    },
    
    filteredItems() {
      if (!this.reports || !Array.isArray(this.reports)) return [];
      
      const filtered = this.reports.filter(item => {
        const matchStatus = !this.localFilter.status || this.localFilter.status === 0 || item.statusId === this.localFilter.status;
        const matchType = !this.localFilter.type || this.localFilter.type === 0 || item.typeId === this.localFilter.type;
        const matchLevel = !this.localFilter.levels || this.localFilter.levels === 0 || item.levelId === this.localFilter.levels;

        const hasAssets = Array.isArray(item.assets) && item.assets.length > 0;
        const hasCars = Array.isArray(item.cars) && item.cars.length > 0;
        
        let matchByRole = true;
        if (this.canSeeAssets && !this.canSeeCars) {
          matchByRole = hasAssets;
        } else if (this.canSeeCars && !this.canSeeAssets) {
          matchByRole = hasCars;
        } else if (this.canSeeCars && this.canSeeAssets) {
          matchByRole = hasAssets || hasCars;
        } else {
          matchByRole = false;
        }

        return matchStatus && matchType && matchLevel && matchByRole;
      });

      // เรียง: เคสที่ยังไม่ปิด (isOpen !== false) ขึ้นก่อน และรายการใหม่ (timeStamps ล่าสุด) อยู่บนสุด
      return filtered.sort((a, b) => {
        const aClosed = a.caseManagement && a.caseManagement.isOpen === false;
        const bClosed = b.caseManagement && b.caseManagement.isOpen === false;
        if (aClosed !== bClosed) {
          return aClosed ? 1 : -1; // closed ไปอยู่หลัง
        }
        const aTime = new Date(a.timeStamps || 0).getTime();
        const bTime = new Date(b.timeStamps || 0).getTime();
        return bTime - aTime; // ใหม่ก่อน
      });
    }
  },
  watch: {
    lang() { this.onInit() },
    
    // Reset filter เมื่อเปลี่ยน route
    '$route'(to, from) {
      if (to.path === '/assets' && from.path === '/dashboard') {
        this.$store.dispatch("Dashboard/filter", { status: null, type: null, levels: null });
      }
    }
  },
  created() {
    this.onInit()
  }
}
</script>

<style scoped>
/* Styling สำหรับ tabs บนพื้นหลังสีเข้ม */



/* สีตัวหนังสือสำหรับ tab ที่ไม่ active - สีขาวอ่อน */
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7) !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0.6rem 1rem !important;
  transition: all 0.3s ease !important;
}

::v-deep .tabs-custom .nav-tabs .nav-item .nav-link .c-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .tabs-custom .nav-tabs .nav-item .nav-link span {
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Hover state - สีขาวชัดเจนขึ้น */
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link:hover {
  color: rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

::v-deep .tabs-custom .nav-tabs .nav-item .nav-link:hover .c-icon,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link:hover span {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* Active state - สีขาวชัดเจน + underline สีขาว + background สีอ่อน */
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active:hover,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active .c-icon,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active span,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active:hover .c-icon,
::v-deep .tabs-custom .nav-tabs .nav-item .nav-link.active:hover span {
  color: #ffffff !important;
}
</style>
